module.exports = __webpack_public_path__ + "img/icon_head@2x.6d3cb718.png";